import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import queryString from "query-string";

export const syncOneChargingApi = createApi({
  reducerPath: "syncOneChargingApi",
  tagTypes: ["syncOneChargingApi"],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_ONE_CHARGING_ENDPOINT,
    prepareHeaders: (headers) => {
      headers.set("withCredentials", false);
      headers.set("Accept", "application/json");
      headers.set("API_KEY", process.env.REACT_APP_ONE_CHARGING_API_KEY);

      return headers;
    },
    paramsSerializer: (params) => {
      return queryString.stringify(params, {
        skipNull: true,
        skipEmptyString: true,
      });
    },
  }),
  endpoints: (builder) => ({
    fetchSyncOneCharging: builder.query({
      query: (params) => ({
        url: "?pagination=none",
        method: "GET",
        params,
      }),

      transformResponse: (response) => response?.data,
    }),
  }),
});

export const { useFetchSyncOneChargingQuery, useLazyFetchSyncOneChargingQuery } =
  syncOneChargingApi;
